import {
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  type User as FirebaseUser
} from 'firebase/auth'

export const signInWithGoogle = async () => {
  const auth = getAuth()
  const provider = new GoogleAuthProvider()
  return signInWithPopup(auth, provider)
}

export const signOut = async () => {
  const auth = getAuth()
  return firebaseSignOut(auth)
}

export const signInWithEmail = async (email: string, password: string) => {
  const auth = getAuth()
  return signInWithEmailAndPassword(auth, email, password)
}

export const createAccount = async (email: string, password: string) => {
  const auth = getAuth()
  return createUserWithEmailAndPassword(auth, email, password)
}

export const sendVerificationEmail = async (user: FirebaseUser) => {
  return sendEmailVerification(user)
}

export const sendResetEmail = async (email: string) => {
  const auth = getAuth()
  return sendPasswordResetEmail(auth, email)
}

export const reloadUser = async (user: FirebaseUser) => {
  await user.reload()
  return user
}
